import { StyledButton } from "./styles";
import { ButtonProps } from "../types";

export const Button = ({ color, children, ...props }: ButtonProps) => (
  <StyledButton color={color} {...props}>
    {children}
  </StyledButton>
);
